import React from 'react';

import type { LinkPreviewData } from './../ricos-types/index.js';

import addLinkPreviewPopoverListener from './LinkPreviewPopoverListener.js';
import LinkPreviewPopoverViewer from './LinkPreviewPopoverViewer.js';
import styles from './statics/styles/link-preview-popover-scss.js';

export type LinkNodePreviewData = {
  position: { top: number; left: number };
  data: LinkPreviewData;
};

export class LinkPreviewPopover extends React.Component<
  {
    container: HTMLElement;
    fetchUrlPreviewData: (url: string) => Promise<LinkPreviewData>;
  },
  { linkPreviewData?: LinkNodePreviewData }
> {
  constructor(props: $TSFixMe) {
    super(props);
    this.state = {};
  }

  removeLinkPreviewPopoverListener!: () => void | null;

  componentDidMount() {
    this.addLinkPreviewPopoverListener(this.props.container);
  }

  componentWillUnmount() {
    this.removeLinkPreviewPopoverListener();
  }

  onPreview = (url: string, position?: { top: number; left: number }) => {
    if (!position) {
      return this.setState({ linkPreviewData: undefined });
    }
    this.props
      .fetchUrlPreviewData(url)
      .then(data => this.setState({ linkPreviewData: { position, data } }));
  };

  addLinkPreviewPopoverListener = (container: $TSFixMe) => {
    if (container && !this.removeLinkPreviewPopoverListener) {
      this.removeLinkPreviewPopoverListener = addLinkPreviewPopoverListener(
        container,
        this.onPreview
      );
    }
  };

  render() {
    const { linkPreviewData } = this.state;

    return linkPreviewData ? (
      <div className={styles.container} style={linkPreviewData.position}>
        <LinkPreviewPopoverViewer {...linkPreviewData.data} />
      </div>
    ) : null;
  }
}
